import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  InOut, 
} from "../../model/model";

import InOutForm from "./InOutForm";
import SessionStore from "../../model/SessionStore";


function CreateInOut() {
  const navigate = useNavigate();

  const onFinish = (obj: InOut) => {
    SessionStore.getClient().createInOut(obj, SessionStore.getBearer()).then(() => {
      navigate(`/ios`);
    });
  };

  
  const inOut :InOut= {id: '',
    type: '',
    subId: '',
    orgId: '',
    siteId: '',
    name: "",
    description: "",
    configView: '',
    config: '',
    lastSeenAt: 0,
    online: false
  
  };


  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>
                <Link to={`/io`}>Device profiles</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Add</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Add IO"
      />
      <Card>
        <InOutForm initialValues={inOut} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default CreateInOut;
